import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock, Mail, Facebook, Instagram } from 'lucide-react';
import contactData from '../data/contact.json';

const Footer = () => {
  return (
    <footer className="bg-[#0F0E0D] text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_74889022-3a14-4f9f-9a7b-69c3c5635b4b/artifacts/gipaf35k_Alibaba%20Logo.png" 
              alt="Ali Baba Logo" 
              className="h-12 mb-4"
            />
            <p className="text-[#E3E3E3] text-sm leading-relaxed">
              Authentischer Geschmack aus Sarnen. Frische Zutaten, liebevoll zubereitet – seit Jahren Ihre erste Adresse für Kebab und vegetarische Spezialitäten.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[#F7E39A] font-semibold mb-4 text-lg">Schnellzugriff</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-[#E3E3E3] hover:text-[#F7E39A] transition-colors text-sm">Home</Link></li>
              <li><Link to="/about" className="text-[#E3E3E3] hover:text-[#F7E39A] transition-colors text-sm">Über uns</Link></li>
              <li><Link to="/menu" className="text-[#E3E3E3] hover:text-[#F7E39A] transition-colors text-sm">Menü</Link></li>
              <li><Link to="/contact" className="text-[#E3E3E3] hover:text-[#F7E39A] transition-colors text-sm">Kontakt</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-[#F7E39A] font-semibold mb-4 text-lg">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <MapPin size={18} className="text-[#F7E39A] flex-shrink-0 mt-0.5" />
                <span className="text-[#E3E3E3]">{contactData.restaurant.address.street}<br />{contactData.restaurant.address.zip} {contactData.restaurant.address.city}, {contactData.restaurant.address.country}</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Phone size={18} className="text-[#F7E39A]" />
                <a href={`tel:${contactData.restaurant.phone}`} className="text-[#E3E3E3] hover:text-[#F7E39A] transition-colors">{contactData.restaurant.phoneDisplay}</a>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Mail size={18} className="text-[#F7E39A]" />
                <a href={`mailto:${contactData.restaurant.email}`} className="text-[#E3E3E3] hover:text-[#F7E39A] transition-colors">{contactData.restaurant.email}</a>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-[#F7E39A] font-semibold mb-4 text-lg">Öffnungszeiten</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start space-x-2">
                <Clock size={18} className="text-[#F7E39A] flex-shrink-0 mt-0.5" />
                <div className="text-[#E3E3E3]">
                  <p className="font-medium">{contactData.hours.weekdays.days}</p>
                  <p>{contactData.hours.weekdays.lunch.open} - {contactData.hours.weekdays.lunch.close}</p>
                  <p>{contactData.hours.weekdays.dinner.open} - {contactData.hours.weekdays.dinner.close}</p>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Clock size={18} className="text-[#F7E39A] flex-shrink-0 mt-0.5" />
                <div className="text-[#E3E3E3]">
                  <p className="font-medium">{contactData.hours.weekend.days}</p>
                  <p>{contactData.hours.weekend.open} - {contactData.hours.weekend.close}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="border-t border-[#F7E39A]/20 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-[#E3E3E3] text-sm mb-4 md:mb-0">
            © 2025 Alibaba Kebab & Vegie. Alle Rechte vorbehalten.
          </p>
          <div className="flex space-x-4">
            <a href={contactData.social.facebook} target="_blank" rel="noopener noreferrer" className="text-[#F7E39A] hover:text-white transition-colors">
              <Facebook size={22} />
            </a>
            <a href={contactData.social.instagram} target="_blank" rel="noopener noreferrer" className="text-[#F7E39A] hover:text-white transition-colors">
              <Instagram size={22} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
